import React, { useEffect, useState } from 'react';
import HeroSection from '../components/home/HeroSection';
import UpcomingEvents from '../components/home/UpcomingEvents';
import RecentBlogPosts from '../components/home/RecentBlogPosts';
import { api } from '../api/client';
import type { ProductItem, EventItem } from '../api/types';
import WorkshopContactSection from '../components/home/WorkshopContactSection';

const Home: React.FC = () => {
  const [products, setProducts] = useState<ProductItem[]>([]);
  const [events, setEvents] = useState<EventItem[]>([]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const [prod, ev] = await Promise.all([api.products(), api.events()]);
        if (mounted) {
          setProducts(prod || []);
          setEvents(ev || []);
        }
      } catch (e) {
        console.error('Failed loading home data', e);
      } finally {
      }
    })();
    return () => { mounted = false; };
  }, []);

  return (
    <>
      <HeroSection />
      <UpcomingEvents events={events} />
      {/* <SubscriptionCTA /> */}
      {/* <FeaturedProducts products={products} /> */}
      <RecentBlogPosts />
      <section className="py-12 bg-[#F9F9F9]">
      </section>
      <WorkshopContactSection />
    </>
  );
};

export default Home;
